export const environment = {
  production: true,
  isStaging: true,
  baseUrl: "https://resourceplanerapidotnet6-staging.azurewebsites.net/api",
  sentry_dsn:"https://98ef7c5702b8a416d8bec297b7966f27@o4508473485230080.ingest.de.sentry.io/4508473486540880"
};
